module.exports = __webpack_public_path__ + "img/testimonial.dd59d71c.jpg";